import { createStore as reduxCreateStore, applyMiddleware } from "redux"
import thunk from "redux-thunk"

import {
  initialState,
  initialNftTransactionStatus,
  initialSaveVideoCollectionState,
} from "./initialState"
import { CHAIN_ID_TO_NETWORK } from "../config/networks"

const reducer = (state, action) => {
  if (action.type === "USER_LOGOUT") {
    return { ...initialState, loginMessage: action.data }
  }
  if (action.type === "LOADING_START") {
    console.log("load 'em up")
    return { ...state, isLoading: true }
  }
  if (action.type === "LOADING_START_MEDIAUPDATE") {
    console.log("load 'em up")
    return { ...state, isLoadingMediaUpdate: true }
  }
  if (action.type === "LOADING_END_MEDIAUPDATE") {
    console.log("load 'em up")
    return { ...state, isLoadingMediaUpdate: false }
  }
  if (action.type === "LOADING_TOKEN_CONFIG") {
    console.log("load 'em up")
    return { ...state, isLoadingTokenConfig: true }
  }
  if (action.type === "LOADING_NOTIFY_CREATE") {
    console.log("load 'em up")
    return { ...state, isLoadingNotifyCreate: true }
  }
  if (action.type === "LOADING_NOTIFY_RESET") {
    return {
      ...state,
      isLoadingNotifyCreate: false,
      forms: {
        ...state.forms,
        notify: { media: [] },
      },
    }
  }
  if (action.type === "LOADING_END") {
    return {
      ...state,
      isLoading: false,
      isLoadingVideoCreatedGrouped: false,
      isLoadingVideoUsers: false,
      isLoadingVideoMini: false,
      isLoadingNotifyCreate: false,
      isLoadingTokenConfig: false,
    }
  }

  if (action.type === "TEMPLATE_CREATE_UPDATE_START") {
    console.log("TEMPLATE_CREATE_UPDATE_START")

    return {
      ...state,
      isLoadingTemplateCreate: true,
    }
  }
  if (action.type === "TEMPLATE_CREATE_UPDATE_COMPLETE") {
    console.log("TEMPLATE_CREATE_UPDATE_COMPLETE")
    // console.log("action.data")
    // console.log(action.data)

    return {
      ...state,
      isLoadingTemplateCreate: false,
      isLoadingTemplateFetch: false,
      forms: {
        ...state.forms,
        // savetemplate: {},
        // edittemplate: {},
        tag: {},
        plannerTemplateSaveData: {},
      },
      // elementsOverlayData: [],
    }
  }

  if (action.type === "UPDATE_LOADING_TEMPLATE_FETCH") {
    return {
      ...state,
      isLoadingTemplateFetch: action.data,
    }
  }

  if (action.type === "COLLECTION_CREATE_UPDATE_START") {
    console.log("COLLECTION_CREATE_UPDATE_START")

    return {
      ...state,
      isLoadingCollectionCreate: true,
    }
  }
  if (action.type === "COLLECTION_CREATE_UPDATE_END") {
    console.log("COLLECTION_CREATE_UPDATE_END")

    return {
      ...state,
      isLoadingCollectionCreate: false,
    }
  }
  if (action.type === "COLLECTION_CREATE_UPDATE_COMPLETE") {
    console.log("COLLECTION_CREATE_UPDATE_COMPLETE")
    // console.log("action.data")
    // console.log(action.data)

    return {
      ...state,
      isLoadingCollectionCreate: false,
      forms: {
        ...state.forms,
        saveVideoCollection: initialSaveVideoCollectionState,
      },
    }
  }
  if (action.type === "COLLECTION_POSTS_UPDATE") {
    console.log("COLLECTION_POSTS_UPDATE")
    // console.log("action.data")
    // console.log(action.data)

    return {
      ...state,
      isLoadingVideoCollectionsList: false,
      collectionPosts: action.data,
    }
  }
  if (action.type === "COLLECTION_MANAGE_PLANNER_ATTRIBUTES") {
    console.log("COLLECTION_MANAGE_PLANNER_ATTRIBUTES")
    console.log("action.data")
    console.log(action.data)
    console.log("state.forms.saveVideoCollection")
    console.log(state.forms.saveVideoCollection)

    if (action.data.mode === "add") {
      // Initialize plannerAttributesSelected if needed
      const currentGroup = Array.isArray(
        state.forms.saveVideoCollection[action.data.group]
      )
        ? state.forms.saveVideoCollection[action.data.group]
        : []

      // Log to help diagnose the issue
      console.log(
        `COLLECTION_MANAGE_PLANNER_ATTRIBUTES - Adding attribute: ${action.data.id}`
      )

      // Create the new attribute object
      const newItem = {
        id: action.data.id,
        cat: action.data.cat,
        content:
          typeof action.data.content === "object"
            ? ""
            : action.data.content || "",
        icon: "Article",
        dateattest: "",
        access: "public",
        accessgroups: [],
        mode: "content",
        elementexport: false,
      }

      // Add the new attribute only if it doesn't already exist
      const exists = currentGroup.some((item) => item.id === action.data.id)
      if (!exists) {
        return {
          ...state,
          forms: {
            ...state.forms,
            saveVideoCollection: {
              ...state.forms.saveVideoCollection,
              [action.data.group]: [...currentGroup, newItem],
            },
          },
        }
      }
      return state
    } else if (action.data.mode === "delete") {
      console.log(
        "Delete operation - Current array:",
        state.forms.saveVideoCollection[action.data.group]
      )
      console.log("ID to delete:", action.data.id)
      console.log("Group to modify:", action.data.group)

      // Make sure we're working with an array
      const currentItems = Array.isArray(
        state.forms.saveVideoCollection[action.data.group]
      )
        ? state.forms.saveVideoCollection[action.data.group]
        : []

      // Enhanced filter with item logging
      const filteredItems = currentItems.filter((item) => {
        const shouldKeep = item.id !== action.data.id
        console.log(`Item ID: ${item.id}, Should keep: ${shouldKeep}`)
        return shouldKeep
      })

      console.log(
        "Items before:",
        currentItems.length,
        "Items after:",
        filteredItems.length
      )
      console.log("Full filtered result:", filteredItems)

      // Create a new state object with the filtered array
      const newState = {
        ...state,
        forms: {
          ...state.forms,
          saveVideoCollection: {
            ...state.forms.saveVideoCollection,
            [action.data.group]: filteredItems,
          },
        },
      }

      console.log(
        "Updated state plannerAttributesSelected length:",
        newState.forms.saveVideoCollection[action.data.group].length
      )

      return newState
    } else if (action.data.mode === "updatecontent") {
      return {
        ...state,
        forms: {
          ...state.forms,
          saveVideoCollection: {
            ...state.forms.saveVideoCollection,
            plannerAttributesSelected: [
              ...state.forms.saveVideoCollection.plannerAttributesSelected.map(
                (attribute) => {
                  if (attribute.id === action.data.id) {
                    return {
                      ...attribute,
                      content: action.data.content,
                    }
                  } else {
                    return attribute
                  }
                }
              ),
            ],
          },
        },
      }
    } else if (action.data.mode === "updatecat") {
      return {
        ...state,
        forms: {
          ...state.forms,
          saveVideoCollection: {
            ...state.forms.saveVideoCollection,
            plannerAttributesSelected: [
              ...state.forms.saveVideoCollection.plannerAttributesSelected.map(
                (attribute) => {
                  if (attribute.id === action.data.id) {
                    return {
                      ...attribute,
                      cat: action.data.content,
                    }
                  } else {
                    return attribute
                  }
                }
              ),
            ],
          },
        },
      }
    } else if (action.data.mode === "updatecatsub") {
      return {
        ...state,
        forms: {
          ...state.forms,
          saveVideoCollection: {
            ...state.forms.saveVideoCollection,
            plannerAttributesSelected: [
              ...state.forms.saveVideoCollection.plannerAttributesSelected.map(
                (attribute) => {
                  if (attribute.id === action.data.id) {
                    return {
                      ...attribute,
                      id: action.data.content,
                    }
                  } else {
                    return attribute
                  }
                }
              ),
            ],
          },
        },
      }
    } else if (action.data.mode === "updateelementexport") {
      return {
        ...state,
        forms: {
          ...state.forms,
          saveVideoCollection: {
            ...state.forms.saveVideoCollection,
            plannerAttributesSelected: [
              ...state.forms.saveVideoCollection.plannerAttributesSelected.map(
                (attribute) => {
                  if (attribute.id === action.data.id) {
                    return {
                      ...attribute,
                      elementexport: action.data.content,
                    }
                  } else {
                    return attribute
                  }
                }
              ),
            ],
          },
        },
      }
    }
  }
  if (action.type === "COLLECTION_MANAGE_DATAFIELDS") {
    console.log("COLLECTION_MANAGE_DATAFIELDS")
    console.log("action.data")
    console.log(action.data)
    console.log("state.forms.saveVideoCollection")
    console.log(state.forms.saveVideoCollection)

    if (action.data.mode === "add") {
      return {
        ...state,
        forms: {
          ...state.forms,
          saveVideoCollection: {
            ...state.forms.saveVideoCollection,
            [action.data.prop]: [
              ...state.forms.saveVideoCollection[action.data.prop],
              { title: "", content: "", fieldtype: "input" },
            ],
          },
        },
      }
    } else if (action.data.mode === "delete") {
      return {
        ...state,
        forms: {
          ...state.forms,
          saveVideoCollection: {
            ...state.forms.saveVideoCollection,
            [action.data.prop]: state.forms.saveVideoCollection[
              action.data.prop
            ].filter((link, i) => i !== action.data.pos),
          },
        },
      }
    }
  }
  if (action.type === "COLLECTION_MANAGE_LINKS") {
    console.log("COLLECTION_MANAGE_LINKS action received")
    console.log("Action data:", action.data)
    console.log("Current state:", state)

    if (action.data.mode === "add") {
      console.log("Adding new link")
      return {
        ...state,
        forms: {
          ...state.forms,
          saveVideoCollection: {
            ...state.forms.saveVideoCollection,
            [action.data.prop]: [
              ...(state.forms.saveVideoCollection[action.data.prop] || []),
              { title: "", protocol: "https", href: "" },
            ],
          },
        },
      }
    } else if (action.data.mode === "delete") {
      return {
        ...state,
        forms: {
          ...state.forms,
          saveVideoCollection: {
            ...state.forms.saveVideoCollection,
            [action.data.prop]: state.forms.saveVideoCollection[
              action.data.prop
            ].filter((link, i) => i !== action.data.pos),
          },
        },
      }
    }
  }
  if (action.type === "COLLECTION_MANAGE_VIDEOS") {
    console.log("COLLECTION_MANAGE_VIDEOS")
    console.log("action.data")
    console.log(action.data)

    if (action.data.mode === "add") {
      return {
        ...state,
        forms: {
          ...state.forms,
          saveVideoCollection: {
            ...state.forms.saveVideoCollection,
            [action.data.prop]: [
              ...state.forms.saveVideoCollection[action.data.prop],
              { ...action.data.videoItem, sort: action.data.pos, price: 0.1 },
            ],
          },
        },
      }
    } else if (action.data.mode === "addnft") {
      let defaultPrice
      let networkValue
      const networkString = CHAIN_ID_TO_NETWORK[action.data.videoItem.chainId]
      if (networkString) {
        defaultPrice =
          networkString.includes("matic") ||
          networkString.includes("mumbai") ||
          networkString.includes("amoy")
            ? 1
            : 0.1
        networkValue = networkString
      }

      let manualChainId
      if (action.data.videoItem.mode === "manual") {
        switch (state.forms.saveVideoCollection.manualNetwork) {
          case "mainnet":
            manualChainId = 1
            break
          case "goerli":
            manualChainId = 5
            break
          case "matic":
            manualChainId = 137
            break
          case "mumbai":
            manualChainId = 80001
            break
          default:
            manualChainId = 0
        }
      }
      return {
        ...state,
        forms: {
          ...state.forms,
          saveVideoCollection: {
            ...state.forms.saveVideoCollection,
            [action.data.prop]: [
              ...state.forms.saveVideoCollection[action.data.prop],
              {
                contract: action.data.videoItem.contract,
                contractAddr: action.data.videoItem.contract.address,
                contractMode: action.data.videoItem.tokenType.replace(
                  "ERC",
                  ""
                ),
                description: action.data.videoItem.description,
                media: action.data.videoItem.raw?.metadata?.animation_url,
                metadata: action.data.videoItem.raw?.metadata,
                poster: action.data.videoItem?.image?.originalUrl,
                title: action.data.videoItem.name,
                tokenId: action.data.videoItem.tokenId,
                manualTokenIdMin:
                  state.forms.saveVideoCollection.manualTokenIdMin,
                manualTokenIdMax:
                  state.forms.saveVideoCollection.manualTokenIdMax,
                mode: action.data.videoItem.mode,
                sort: action.data.pos,
                chainId:
                  action.data.videoItem.mode === "manual"
                    ? manualChainId
                    : action.data.videoItem.chainId,
                network:
                  action.data.videoItem.mode === "manual"
                    ? state.forms.saveVideoCollection.manualNetwork
                    : networkValue,
                supplyAvail: action.data.videoItem.balance,
                supplySelected: action.data.videoItem.balance,
                price: defaultPrice,
              },
            ],
          },
        },
      }
    } else if (action.data.mode === "addnftoffchain") {
      return {
        ...state,
        forms: {
          ...state.forms,
          saveVideoCollection: {
            ...state.forms.saveVideoCollection,
            [action.data.prop]: [
              ...state.forms.saveVideoCollection[action.data.prop],
              {
                description: action.data.videoItem.desc,
                poster: action.data.videoItem.plannerProductMedia?.asset,
                title: action.data.videoItem.title,
                id: action.data.videoItem.id,
                anonUserId: action.data.videoItem.anonUserId,
                sort: action.data.pos,
                supply: action.data.videoItem.supply,
              },
            ],
          },
        },
      }
    } else if (action.data.mode === "delete") {
      return {
        ...state,
        forms: {
          ...state.forms,
          saveVideoCollection: {
            ...state.forms.saveVideoCollection,
            [action.data.prop]: state.forms.saveVideoCollection[
              action.data.prop
            ].filter((link, i) => i !== action.data.pos),
          },
        },
      }
    } else if (action.data.mode === "edit") {
      return {
        ...state,
        forms: {
          ...state.forms,
          saveVideoCollection: {
            ...state.forms.saveVideoCollection,
            [action.data.prop]: state.forms.saveVideoCollection[
              action.data.prop
            ].map((propItem, i) => {
              if (i === action.data.pos) {
                return { ...propItem, [action.data.subprop]: action.data.val }
              } else {
                return propItem
              }
            }),
          },
        },
      }
    } else if (action.data.mode === "reset") {
      return {
        ...state,
        forms: {
          ...state.forms,
          saveVideoCollection: {
            ...state.forms.saveVideoCollection,
            [action.data.prop]: [],
          },
        },
      }
    }
  }

  if (action.type === "COLLECTION_EVENT_EDIT_COPY") {
    console.log("COLLECTION_EVENT_EDIT_COPY")
    console.log(action.data)
    return {
      ...state,
      forms: {
        ...state.forms,
        saveVideoCollection: action.data
          ? {
              ...state.forms.saveVideoCollection, //new
              ...action.data,
              eventSendMessage: [
                {
                  cat:
                    action.data && action.data.eventSendCategory
                      ? action.data.eventSendCategory
                      : "",
                  content:
                    action.data && action.data.message
                      ? action.data.message
                      : "",
                  dateattest:
                    action.data &&
                    action.data.utility &&
                    action.data.utility.dateattest
                      ? action.data.utility.dateattest
                      : "",
                  mode:
                    action.data &&
                    action.data.utility &&
                    action.data.utility.mode
                      ? action.data.utility.mode
                      : "",
                  access:
                    action.data &&
                    action.data.utility &&
                    action.data.utility.access
                      ? action.data.utility.access
                      : "",
                  accessgroups:
                    action.data &&
                    action.data.utility &&
                    action.data.utility.accessgroups
                      ? action.data.utility.accessgroups
                      : "",
                  itemgroupid:
                    action.data &&
                    action.data.utility &&
                    action.data.utility.itemgroupid
                      ? action.data.utility.itemgroupid
                      : "",
                  icon:
                    action.data &&
                    action.data.utility &&
                    action.data.utility.icon
                      ? action.data.utility.icon
                      : "",
                  id:
                    action.data && action.data.eventSendCategorySub
                      ? action.data.eventSendCategorySub
                      : null,
                  eventtime:
                    action.data && action.data.eventTime
                      ? action.data.eventTime
                      : null,
                },
              ],
              eventSendId:
                action.data && action.data.id ? action.data.id : null,

              // eventSendCategory:
              //   action.data && action.data.eventSendCategory
              //     ? action.data.eventSendCategory
              //     : "",
              // eventSendMessage:
              //   action.data && action.data.message ? action.data.message : [],

              // eventSendIcon:
              //   action.data && action.data.utility && action.data.utility.icon
              //     ? action.data.utility.icon
              //     : "",
              // eventSendDateAttestation:
              //   action.data &&
              //   action.data.utility &&
              //   action.data.utility.dateattest
              //     ? action.data.utility.dateattest
              //     : "",
              nftAuthOffchain:
                action.data && action.data.nftAuthOffchain
                  ? action.data.nftAuthOffchain
                  : [],
            }
          : state.saveVideoCollection,
      },
    }
  }
  if (action.type === "COLLECTION_EDIT_COPY") {
    console.log("COLLECTION_EDIT_COPY")
    console.log(action.data)
    return {
      ...state,
      forms: {
        ...state.forms,
        // offchainOptions: {
        //   ...state.forms.offchainOptions,
        //   eventOffchain:
        //     action.data &&
        //     action.data.nftAuthOffchain &&
        //     action.data.nftAuthOffchain.length > 0
        //       ? true
        //       : false,
        // },
        saveVideoCollection: action.data
          ? {
              ...state.forms.saveVideoCollection, //new
              ...action.data,
              action: "none",
              metadata: 0,
              image:
                action.data && action.data.landing && action.data.landing.image
                  ? action.data.landing.image
                  : "",
              imageMarquee:
                action.data &&
                action.data.landing &&
                action.data.landing.imageMarquee
                  ? action.data.landing.imageMarquee
                  : action.data && action.data.poster
                  ? action.data.poster
                  : "",
              imageMarqueeSrc:
                action.data && action.data.imageMarqueeSrc
                  ? action.data.imageMarqueeSrc
                  : "",
              link:
                action.data && action.data.link
                  ? action.data.link
                  : action.data &&
                    action.data.landing &&
                    action.data.landing.link
                  ? action.data.landing.link
                  : [],
              cta:
                action.data && action.data.landing && action.data.landing.cta
                  ? action.data.landing.cta
                  : [],
              dataFields:
                action.data &&
                action.data.landing &&
                action.data.landing.dataFields
                  ? action.data.landing.dataFields
                  : [],
              bgcolor:
                action.data &&
                action.data.landing &&
                action.data.landing.bgcolor
                  ? action.data.landing.bgcolor
                  : "#cccccc",
              displayTitle:
                action.data &&
                action.data.landing &&
                action.data.landing.hasOwnProperty("displayTitle")
                  ? action.data.landing.displayTitle
                  : true,
              // plannerAttributesSelected:
              //   action.data &&
              //   action.data.plannerAttributesSelected &&
              //   action.data.plannerAttributesSelected.length > 0
              //     ? action.data.plannerAttributesSelected
              //     : [],
            }
          : state.saveVideoCollection,
      },
    }
  }
  if (action.type === "NOTIFY_ITEM_COPY") {
    console.log("NOTIFY_ITEM_COPY")
    console.log(action.data)
    return {
      ...state,
      forms: {
        ...state.forms,
        // offchainOptions: {
        //   ...state.forms.offchainOptions,
        //   eventOffchain:
        //     action.data &&
        //     action.data.nftAuthOffchain &&
        //     action.data.nftAuthOffchain.length > 0
        //       ? true
        //       : false,
        // },
        notify: action.data
          ? {
              ...state.forms.notify,
              id: action.data.id,
              title: action.data.title,
              attributes: action.data.attributes,
              activecollectionid: action.data.activecollectionid,
            }
          : state.forms.notify,
      },
    }
  }

  if (action.type === "CLEAR_FORM_FIELD") {
    console.log("CLEAR_FORM_FIELD")
    console.log(action.data)
    let val = {}
    if (
      action &&
      action.data &&
      action.data.prop &&
      action.data.prop === "workingtags"
    ) {
      val = []
    } else if (
      action &&
      action.data &&
      action.data.prop &&
      action.data.prop === "saveVideoCollection"
    ) {
      console.log("initialSaveVideoCollectionState")
      console.log(initialSaveVideoCollectionState)
      val = initialSaveVideoCollectionState
    } else if (
      action &&
      action.data &&
      action.data.prop &&
      action.data.prop === "notify"
    ) {
      console.log("initialFormsNotifyState")
      console.log(initialFormsNotifyState)
      val = initialFormsNotifyState
    }
    return {
      ...state,
      forms: {
        ...state.forms,
        [action.data.prop]: val,
      },
    }
  }

  if (action.type === "EMAILVERIFY_FIELD_UPDATE") {
    // console.log("EMAILVERIFY_FIELD_UPDATE")
    // console.log("action.data")
    // console.log(action.data)

    return {
      ...state,
      emailVerifyMode: action.data,
    }
  }
  if (action.type === "EMAILVERIFY_SEND_ERRORS") {
    return {
      ...state,
      forms: {
        ...state.forms,
        userdetailemail: {
          ...state.forms.userdetailemail,
          error: action.data ? action.data : "",
        },
      },
    }
  }

  if (action.type === "EMAILVERIFY_UPDATE_COMPLETE") {
    console.log("EMAILVERIFY_UPDATE_COMPLETE")
    // console.log("action.data")
    // console.log(action.data)

    let returnObj = {
      email: state.userdetail.email,
      mobile: state.userdetail.mobile,
      verifycode: "",
      error: "",
    }

    let errorMsg
    if (action.error) errorMsg = action.error
    return {
      ...state,
      emailVerifyMode: action.data,
      forms: {
        ...state.forms,
        userdetailemail: {
          ...returnObj,
          error: errorMsg ? errorMsg : "",
        },
      },
      userdetailemail: returnObj,
    }
  }
  if (action.type === "FORMS_FIELD_UPDATE") {
    console.log("FORMS_FIELD_UPDATE")
    // console.log("action.data")
    // console.log(action.data)

    return {
      ...state,
      isLoading: false,
      forms: {
        ...state.forms,
        [action.data.prop]: action.data.val,
      },
    }
  }
  if (action.type === "PUBLISHER_FIELD_UPDATE") {
    console.log(`PUBLISHER_FIELD_UPDATE for ${action.data.prop}`)
    // if (
    //   action.data.prop === "userimages" ||
    //   action.data.prop === "useruploadimages" ||
    //   action.data.prop === "aifiles"
    // ) {
    //   console.log(
    //     `Updating ${action.data.prop} with ${action.data.val.length || 0} items`
    //   )
    // }

    // if (
    //   action.data.prop === "userimages" &&
    //   state.publisher.userimages &&
    //   action.data.val.length === state.publisher.userimages.length
    // ) {
    //   console.log(`Skip redundant update for ${action.data.prop} - same length`)
    //   return {
    //     ...state,
    //     isLoading: false,
    //   }
    // }

    // if (
    //   action.data.prop === "useruploadimages" &&
    //   state.publisher.useruploadimages &&
    //   action.data.val.length === state.publisher.useruploadimages.length
    // ) {
    //   console.log(`Skip redundant update for ${action.data.prop} - same length`)
    //   return {
    //     ...state,
    //     isLoading: false,
    //   }
    // }

    // if (
    //   action.data.prop === "aifiles" &&
    //   state.publisher.aifiles &&
    //   action.data.val.length === state.publisher.aifiles.length
    // ) {
    //   console.log(`Skip redundant update for ${action.data.prop} - same length`)
    //   return {
    //     ...state,
    //     isLoading: false,
    //   }
    // }

    return {
      ...state,
      isLoading: false,
      publisher: {
        ...state.publisher,
        [action.data.prop]: action.data.val,
      },
    }
  }

  if (action.type === "PROFILE_EDIT_COPY") {
    console.log("PROFILE_EDIT_COPY")
    console.log(state.userdetail)
    return {
      ...state,
      forms: {
        ...state.forms,
        userdetail: action.data ? action.data : state.userdetail,
        userdetailemail: action.data
          ? {
              email: action.data.email,
              mobile: action.data.mobile,
              displayname: action.data.displayname,
              verifycode: "",
              error: "",
            }
          : state.userdetailemail,
      },
    }
  }
  if (action.type === "PROFILE_EDIT_EMAIL_COPY") {
    console.log("PROFILE_EDIT_EMAIL_COPY")
    console.log(state.userdetailemail)
    return {
      ...state,
      forms: {
        ...state.forms,
        userdetailemail: action.data ? action.data : state.userdetailemail,
      },
    }
  }

  if (action.type === "USER_LOGIN") {
    console.log("createStore - USER_LOGIN - action.data")
    console.log(action.data)
    return {
      ...state,
      isLoading: false,
      userlogin: action.data,
      usersub: action.data.sub,
      usererror: {},
    }
  }

  if (action.type === "USER_LOGIN_ERROR") {
    return { ...state, isLoading: false, usererror: action.data }
  }
  if (action.type === "USER_PROFILE_DETAIL_REPLACE") {
    console.log("createStore - USER_PROFILE_DETAIL_REPLACE - action.data")
    console.log(action.data)
    return {
      ...state,
      isLoading: false,
      isProfileUpdateComplete: true,
      userdetail: action.data,
      userdetailemail: {
        email: action.data.email,
        mobile: action.data.mobile,
        displayname: action.data.displayname,
        verifycode: "",
        error: "",
      },
    }
  }
  if (action.type === "USER_PROFILE_DETAIL_COMPLETE") {
    return {
      ...state,
      isProfileUpdateComplete: false,
    }
  }
  if (action.type === "COMPANY_DETAIL_UPDATE") {
    console.log("createStore - COMPANY_DETAIL_UPDATE")
    console.log(action.data)
    return {
      ...state,
      isLoading: false,
      company: { ...state.company, [action.data.prop]: action.data.val },
    }
  }

  if (action.type === "COMPANY_DETAIL_REPLACE") {
    console.log("createStore - COMPANY_DETAIL_REPLACE - action.data")
    console.log(action.data)
    // if (action.data.user) {
    //   delete action.data.user.email
    // }
    return {
      ...state,
      isLoading: false,
      company: action.data.company,
      userdetail: action.data.user,
      userdetailemail: {
        email: action.data.user.email,
        mobile:
          action.data.user && action.data.user.mobile
            ? action.data.user.mobile
            : "",
        displayname: action.data.user.displayname,
        verifycode: "",
        error: "",
      },
      usererror: {},
    }
  }

  if (action.type === "UPDATE_FORM_FIELD") {
    // Special handling for plannerAttributesSelected to ensure it's always an array
    if (action.data.prop === "plannerAttributesSelected") {
      const formValue = action.data.val || []

      if (!Array.isArray(formValue)) {
        action.data.val = []
      }
    }

    return {
      ...state,
      forms: {
        ...state.forms,
        [action.data.group]: {
          ...state.forms[action.data.group],
          [action.data.prop]: action.data.val,
        },
      },
    }
  }
  if (action.type === "UPDATE_FORM_FIELD_SUB") {
    console.log("UPDATE_FORM_FIELD_SUB")
    console.log("action.data")
    console.log(action.data)
    return {
      ...state,
      isLoading: false,
      forms: {
        ...state.forms,
        [action.data.group]: {
          ...state.forms[action.data.group],
          [action.data.prop]: {
            ...state.forms[action.data.group][action.data.prop],
            [action.data.sub]: action.data.val,
          },
        },
      },
    }
  }
  if (action.type === "UPDATE_FORM_FIELD_SINGLE") {
    console.log("UPDATE_FORM_FIELD_SINGLE")
    console.log("action.data")
    console.log(action.data)

    return {
      ...state,
      isLoading: false,
      forms: {
        ...state.forms,
        [action.data.prop]: action.data.val,
      },
    }
  }

  if (action.type === "UPDATE_FORM_FIELD_USERGROUP") {
    console.log("UPDATE_FORM_FIELD_USERGROUP")
    console.log(action.data)

    const { group, index, fname, lname, email, planmodules } = action.data

    if (
      group === "usersmodify" ||
      group === "usersmodifyemail" ||
      group === "usersmodifymodule"
    ) {
      return {
        ...state,
        isLoading: false,
        company: {
          ...state.company,
          users: state.company.users.map((userDetail, i) =>
            i === index
              ? {
                  ...userDetail,
                  index,
                  fname: fname === "" ? "" : fname ? fname : userDetail.fname,
                  lname: lname === "" ? "" : lname ? lname : userDetail.lname,
                  email: email === "" ? "" : email ? email : userDetail.email,
                  modified: true,
                  modifiedemail:
                    group === "usersmodifyemail" ||
                    userDetail.modifiedemail === true
                      ? true
                      : false,
                  planmodules:
                    group === "usersmodifymodule" &&
                    planmodules &&
                    planmodules.val === false
                      ? userDetail.planmodules.filter(
                          (module) => module !== planmodules.name
                        ) //if removing then filter through and take out the target module
                      : group === "usersmodifymodule" &&
                        planmodules &&
                        planmodules.val === true
                      ? [...userDetail.planmodules, planmodules.name] //otherwise add it to the module list
                      : userDetail.planmodules,
                }
              : userDetail
          ),
        },
      }
    } else if (group === "usersadd") {
      return {
        ...state,
        isLoading: false,
        company: {
          ...state.company,
          users: [
            ...state.company.users,
            {
              id: "",
              fname: "",
              lname: "",
              email: "",
              planmodules: [],
              add: true,
            },
          ],
        },
      }
    } else if (group === "userstempdelete") {
      return {
        ...state,
        isLoading: false,
        company: {
          ...state.company,
          users: [...state.company.users.filter((user, i) => i !== index)],
        },
      }
    } else if (group === "usersdelete" || group === "usersdeleteundo") {
      return {
        ...state,
        isLoading: false,
        company: {
          ...state.company,
          users: state.company.users.map((userDetail, i) =>
            i === index
              ? {
                  ...userDetail,
                  delete: group === "usersdelete" ? true : false,
                }
              : userDetail
          ),
        },
      }
    }
  }

  if (action.type === "UPDATE_FORM_FIELD_COLLECTION_LINK") {
    console.log("UPDATE_FORM_FIELD_COLLECTION_LINK")
    console.log("action.data")
    console.log(action.data)
    return {
      ...state,
      isLoading: false,
      forms: {
        ...state.forms,
        saveVideoCollection: {
          ...state.forms.saveVideoCollection,
          [action.data.group]: state.forms.saveVideoCollection[
            action.data.group
          ].map((link, i) => {
            if (i === action.data.pos) {
              return {
                ...link,
                [action.data.prop]: action.data.val,
              }
            } else {
              return link
            }
          }),
        },
      },
    }
  }

  if (action.type === "IMAGEUPLOAD_START") {
    console.log("IMAGEUPLOAD_START")
    return {
      ...state,
      isLoadingImageUpload: true,
    }
  }
  if (action.type === "IMAGEUPLOAD_PROGRESS") {
    console.log("IMAGEUPLOAD_PROGRESS")
    return {
      ...state,
      imageuploadprogress: {
        ...state.imageuploadprogress,
        [action.data.prop]: { progress: action.data.val, loc: action.data.loc },
      },
    }
  }
  if (action.type === "IMAGEUPLOAD_FINISH") {
    console.log("IMAGEUPLOAD_FINISH")
    return {
      ...state,
      isLoadingImageUpload: false,
      imageuploadprogress: {
        ...state.imageuploadprogress,
        [action.data.prop]: { progress: action.data.val, loc: action.data.loc },
      },
    }
  }
  if (action.type === "IMAGEUPLOAD_RESET") {
    console.log("IMAGEUPLOAD_RESET")
    return {
      ...state,
      isLoadingImageUpload: false,
      isLoadingImageDelete: false,
      imageuploadprogress: {},
      imagetags: [],
      forms: {
        ...state.forms,
        saveimage: {},
        deleteimage: [],
        deleteimagefiles: [],
      },
    }
  }

  if (action.type === "IMAGEDELETE_START") {
    console.log("IMAGEDELETE_START")
    return {
      ...state,
      isLoadingImageDelete: true,
    }
  }

  if (action.type === "IMAGEDELETE_FINISH") {
    console.log("IMAGEDELETE_FINISH")
    return {
      ...state,
      isLoadingImageDelete: "complete",
      forms: {
        ...state.forms,
        deleteimage: [],
        deleteimagefiles: [],
      },
    }
  }
  if (action.type === "IMAGEDELETE_COMPLETE") {
    console.log("IMAGEDELETE_COMPLETE")
    return {
      ...state,
      isLoadingImageDelete: false,
    }
  }

  if (action.type === "USERGROUP_CREATE_UPDATE_START") {
    console.log("USERGROUP_CREATE_UPDATE_START")

    return {
      ...state,
      isLoadingUserGroup: true,
    }
  }

  if (action.type === "USERGROUP_CREATE_UPDATE_COMPLETE") {
    console.log("USERGROUP_CREATE_UPDATE_COMPLETE")
    // console.log("action.data")
    // console.log(action.data)

    return {
      ...state,
      isLoadingUserGroup: false,
      userGroupUpdateComplete: true,
    }
  }

  if (action.type === "USERGROUP_CREATE_UPDATE_RESET") {
    console.log("USERGROUP_CREATE_UPDATE_RESET")

    return {
      ...state,
      userGroupUpdateComplete: false,
    }
  }

  if (action.type === "IMAGELIBRARY_CONTEXT_REPLACE") {
    console.log("IMAGELIBRARY_CONTEXT_REPLACE")
    // console.log("action.data")
    // console.log(action.data)

    return {
      ...state,
      imagelibrary: action.data,
    }
  }
  if (action.type === "USERPROFILE_CREATE_UPDATE_START") {
    console.log("USERPROFILE_CREATE_UPDATE_START")
    // console.log("action.data")
    // console.log(action.data)

    return {
      ...state,
      isLoading: true,
    }
  }

  if (action.type === "VIDEO_STATUS_DELETE_MESSAGE") {
    console.log("VIDEO_STATUS_DELETE_MESSAGE")
    return {
      ...state,
      videoStatusDeleteVideoMessage: action.data,
    }
  }
  if (action.type === "VIDEO_STATUS_RENDERLIST_ISLOADING") {
    console.log("VIDEO_STATUS_RENDERLIST_ISLOADING")
    return {
      ...state,
      isLoadingVideoRenderList: true,
    }
  }
  if (action.type === "VIDEO_STATUS_RENDERLIST_ISLOADING_RESET") {
    console.log("VIDEO_STATUS_RENDERLIST_ISLOADING_RESET")
    return {
      ...state,
      isLoadingVideoRenderList: false,
    }
  }
  if (action.type === "VIDEO_STATUS_RENDERLIST_REPLACE") {
    console.log("VIDEO_STATUS_RENDERLIST_REPLACE")
    return {
      ...state,
      isLoadingVideoRenderList: false,
      videoRenderList: action.data,
    }
  }

  if (action.type === "VIDEO_STATUS_RECHECK_INCREMENT") {
    console.log("VIDEO_STATUS_RECHECK_INCREMENT")
    return {
      ...state,
      videoStatusRecheckActive: true,
      videoStatusRecheckCounter: action.data,
    }
  }
  if (action.type === "VIDEO_STATUS_RECHECK_RESET") {
    console.log("VIDEO_STATUS_RECHECK_RESET")
    return {
      ...state,
      videoStatusRecheckActive: false,
      videoStatusRecheckCounter: 0,
    }
  }
  if (action.type === "LOADING_REPORTING_COLLECTIONS") {
    console.log("LOADING_REPORTING_COLLECTIONS")
    return {
      ...state,
      reportingCollections: [],
      reportingCollectionsOffchain: [],
      isLoadingVideoCollectionsList: true,
    }
  }
  if (action.type === "LOADING_REPORTING_COLLECTIONS_REPLACE") {
    console.log("LOADING_REPORTING_COLLECTIONS_REPLACE")
    // Don't update if already loaded and has same length (prevents infinite loops)
    if (
      state.reportingCollections &&
      action.data &&
      state.reportingCollections.length === action.data.length &&
      !state.isLoadingVideoCollectionsList
    ) {
      console.log("Skipping duplicate LOADING_REPORTING_COLLECTIONS_REPLACE")
      return state
    }

    return {
      ...state,
      isLoadingVideoCollectionsList: false,
      reportingCollections:
        action.data && action.data.length > 0
          ? action.data.map((item) => ({
              ...item,
              manualContractAddr: "",
              manualTokenId: "",
              manualTokenIdMin: "",
              manualTokenIdMax: "",
              manualNetwork: "mainnet",
            }))
          : [],
    }
  }
  if (action.type === "LOADING_REPORTING_COLLECTIONS_ITEMGROUP_REPLACE") {
    console.log("LOADING_REPORTING_COLLECTIONS_OFFCHAIN_REPLACE")
    return {
      ...state,
      isLoading: false,
      reportingCollectionsItemGroup:
        action.data && action.data.length > 0 ? action.data : [],
    }
  }
  if (action.type === "LOADING_REPORTING_COLLECTIONS_OFFCHAIN_REPLACE") {
    console.log("LOADING_REPORTING_COLLECTIONS_OFFCHAIN_REPLACE")
    return {
      ...state,
      isLoadingVideoCollectionsList: false,
      reportingCollectionsOffchain:
        action.data && action.data.length > 0 ? action.data : [],
    }
  }
  if (action.type === "LOADING_USERNFTS") {
    console.log("LOADING_USERNFTS")
    return {
      ...state,
      isLoadingUserNfts: true,
    }
  }
  if (action.type === "LOADING_NFTPROJECT") {
    console.log("LOADING_NFTPROJECT")
    return {
      ...state,
      isLoadingNftProject: true,
    }
  }
  if (action.type === "VIDEO_RENDER_CURRENT_STATUS_REPLACE") {
    console.log("VIDEO_RENDER_CURRENT_STATUS_REPLACE")
    console.log(action.data)
    return {
      ...state,
      videoRenderCurrentStatus: action.data,
    }
  }
  if (action.type === "LOGIN_CURRENT_STATUS_REPLACE") {
    console.log("LOGIN_CURRENT_STATUS_REPLACE")
    console.log(action.data)
    return {
      ...state,
      loginCurrentStatus: action.data,
    }
  }
  if (action.type === "LOGIN_CURRENT_SUSPENDED_REPLACE") {
    console.log("LOGIN_CURRENT_SUSPENDED_REPLACE")
    console.log(action.data)
    return {
      ...state,
      loginSuspended: action.data,
    }
  }

  if (action.type === "GETTING_STARTED_POSITION_REPLACE") {
    console.log("GETTING_STARTED_POSITION_REPLACE")
    console.log(action.data)
    return {
      ...state,
      gettingStartedPos: action.data,
    }
  }
  if (action.type === "GETTING_STARTED_MODULE_REPLACE") {
    console.log("GETTING_STARTED_MODULE_REPLACE")
    console.log(action.data)
    return {
      ...state,
      gettingStartedModule: action.data,
    }
  }

  if (action.type === "MINTING_ITEM_REPLACE") {
    console.log("MINTING_ITEM_REPLACE")
    console.log(action.data)
    return {
      ...state,
      mintingItem: action.data,
    }
  }
  if (action.type === "MINTING_ITEM_UPDATE") {
    console.log("MINTING_ITEM_UPDATE")
    console.log(action.data)
    return {
      ...state,
      mintingItem: {
        ...state.mintingItem,
        [action.data.prop]: action.data.val,
      },
    }
  }
  if (action.type === "USER_NFTS_REPLACE") {
    console.log("USER_NFTS_REPLACE")
    console.log(action.data)
    return {
      ...state,
      userNfts: action.data,
      isLoadingUserNfts: false,
    }
  }
  if (action.type === "UPDATE_WALLET_ADDRESS") {
    console.log("UPDATE_WALLET_ADDRESS")
    return {
      ...state,
      walletAddress: action.data,
    }
  }
  if (action.type === "UPDATE_WALLET_CHAIN") {
    console.log("UPDATE_WALLET_CHAIN")
    return {
      ...state,
      walletChainId: action.data,
    }
  }
  if (action.type === "UPDATE_WALLET_PROVIDER") {
    console.log("UPDATE_WALLET_PROVIDER")
    return {
      ...state,
      walletProvider: action.data,
    }
  }
  if (action.type === "UPDATE_WALLET_STATUS") {
    console.log("UPDATE_WALLET_STATUS")
    return {
      ...state,
      walletStatus: action.data,
    }
  }
  if (action.type === "UPDATE_WALLET_WEB3") {
    console.log("UPDATE_WALLET_WEB3")
    return {
      ...state,
      walletWeb3: action.data,
    }
  }
  if (action.type === "UPDATE_WALLET_SIGNER") {
    console.log("UPDATE_WALLET_SIGNER")
    return {
      ...state,
      walletSigner: action.data,
    }
  }
  if (action.type === "UPDATE_ALCHEMY_NFT_LIST") {
    console.log("UPDATE_ALCHEMY_NFT_LIST")
    return {
      ...state,
      userNftsAlchemy: action.data,
      isLoadingUserNfts: false,
    }
  }
  if (action.type === "UPDATE_NFT_TRANSACTION_STATUS") {
    console.log("UPDATE_NFT_TRANSACTION_STATUS")
    console.log("action.data")
    console.log(action.data)

    let returnObj = {
      ...state,
      nftTransactionStatus: action.data,
    }

    if (action.data && action.data.success === false) {
      returnObj.isLoadingCollectionCreate = false
      returnObj.isLoadingVideoRenderList = false
    }

    return returnObj
  }
  if (action.type === "RESET_NFT_TRANSACTION_STATUS") {
    console.log("RESET_NFT_TRANSACTION_STATUS")

    return {
      ...state,
      nftTransactionStatus: initialNftTransactionStatus,
      isLoadingCollectionCreate: false,
    }
  }

  if (action.type === "UPDATE_NFT_PROJECTS") {
    console.log("UPDATE_NFT_PROJECTS")
    return {
      ...state,
      nftProjects: action.data,
      isLoadingNftProject: false,
    }
  }
  if (action.type === "UPDATE_NFT_PROJECT_SELECTED") {
    console.log("UPDATE_NFT_PROJECT_SELECTED")
    return {
      ...state,
      nftProjectSelected: action.data,
    }
  }
  if (action.type === "UPDATE_NFT_PROJECT_SELECTED_FIELD") {
    console.log("UPDATE_NFT_PROJECT_SELECTED_FIELD")
    console.log("UPDATE_NFT_PROJECT_SELECTED_FIELD - action.data.prop")
    console.log(action.data.prop)
    console.log("UPDATE_NFT_PROJECT_SELECTED_FIELD - action.data.val")
    console.log(action.data.val)
    return {
      ...state,
      nftProjectSelected: {
        ...state.nftProjectSelected,
        [action.data.prop]: action.data.val,
      },
    }
  }
  if (action.type === "UPDATE_NFT_PROJECT_ASSETS_WORKING") {
    console.log("UPDATE_NFT_PROJECT_ASSETS_WORKING")
    return {
      ...state,
      nftAssetsWorking: action.data,
      isLoading: false,
    }
  }
  if (action.type === "UPDATE_NFT_PROJECT_METADATA_WORKING") {
    console.log("UPDATE_NFT_PROJECT_METADATA_WORKING")
    return {
      ...state,
      nftMetadataWorking: action.data,
      isLoading: false,
    }
  }
  if (action.type === "UPDATE_NFT_MANUAL_METADATA") {
    console.log("UPDATE_NFT_MANUAL_METADATA")
    return {
      ...state,
      manualTokenMetadata: action.data,
      isLoading: false,
    }
  }
  if (action.type === "UPDATE_PLANNER_TEMPLATES") {
    console.log("UPDATE_PLANNER_TEMPLATES")
    return {
      ...state,
      plannerTemplates: action.data,
      isLoading: false,
    }
  }
  if (action.type === "UPDATE_PLATFORM_SETTINGS") {
    console.log("UPDATE_PLATFORM_SETTINGS")
    return {
      ...state,
      platformSettings: action.data,
      isLoading: false,
    }
  }
  if (action.type === "UPDATE_PLATFORM_SETTINGS_SAVE_SUCCESS") {
    console.log("UPDATE_PLATFORM_SETTINGS_SAVE_SUCCESS")
    return {
      ...state,
      isLoading: false,
      platformSettingsSaveSuccess: true,
    }
  }
  if (action.type === "UPDATE_PLATFORM_SETTINGS_RESET") {
    console.log("UPDATE_PLATFORM_SETTINGS_RESET")
    return {
      ...state,
      isLoading: false,
      platformSettingsSaveSuccess: false,
    }
  }
  if (action.type === "UPDATE_PLATFORM_SETTINGS_ITEM") {
    console.log("UPDATE_PLATFORM_SETTINGS_ITEM")
    console.log(action.data)
    if (action.data.mode === "add") {
      return {
        ...state,
        platformSettings: {
          ...state.platformSettings,
          [action.data.group]: [
            ...state.platformSettings[action.data.group],
            {
              id: `custom${action.data.id}`,
              cat: `${action.data.cat}`,
              label: ``,
              publish: 1,
              subcat: [],
            },
          ],
        },
        isLoading: false,
      }
    } else if (action.data.mode === "addsub") {
      return {
        ...state,
        platformSettings: {
          ...state.platformSettings,
          [action.data.group]: state.platformSettings[action.data.group].map(
            (item) => {
              if (item.id === action.data.id) {
                return {
                  ...item,
                  subcat: [
                    ...(item?.subcat ? item.subcat : []),
                    {
                      id: `${action.data.cat}-${action.data.subcat}`,
                      cat: action.data.cat,
                      label: "",
                      content: "",
                    },
                  ],
                }
              } else {
                return item
              }
            }
          ),
        },
        isLoading: false,
      }
    } else if (action.data.mode === "delete") {
      return {
        ...state,
        platformSettings: {
          ...state.platformSettings,
          [action.data.group]: state.platformSettings[action.data.group].filter(
            (item, i) => item.id !== action.data.id
          ),
        },
      }
    } else if (action.data.mode === "deletesub") {
      return {
        ...state,
        platformSettings: {
          ...state.platformSettings,
          [action.data.group]: state.platformSettings[action.data.group].map(
            (item) => {
              if (item.id === action.data.id) {
                return {
                  ...item,
                  subcat: item?.subcat
                    ? item.subcat.filter(
                        (subitem) => subitem.id !== action.data.subcat
                      )
                    : [],
                }
              } else {
                return item
              }
            }
          ),
        },
      }
    } else if (action.data.mode === "updatecontent") {
      return {
        ...state,
        platformSettings: {
          ...state.platformSettings,
          [action.data.group]: [
            ...state.platformSettings[action.data.group].map((item) => {
              if (item.cat === action.data.cat) {
                return {
                  ...item,
                  [action.data.prop]: action.data.content,
                }
              } else {
                return item
              }
            }),
          ],
        },
      }
    } else if (action.data.mode === "updatecontentsub") {
      return {
        ...state,
        platformSettings: {
          ...state.platformSettings,
          [action.data.group]: state.platformSettings[action.data.group].map(
            (item) => {
              if (item.id === action.data.id) {
                return {
                  ...item,
                  subcat: item?.subcat?.map((subitem) => {
                    if (subitem.id === action.data.subcat) {
                      return {
                        ...subitem,
                        content: action.data.content,
                        label: action.data.content,
                      }
                    } else {
                      return subitem
                    }
                  }),
                }
              } else {
                return item
              }
            }
          ),
        },
        isLoading: false,
      }
    }
  }

  if (action.type === "TOKEN_CONFIG_REPLACE") {
    console.log("TOKEN_CONFIG_REPLACE")
    console.log(action.data)
    let returnObj = {}
    if (action.data && action.data.tokenConfigData) {
      console.log("cond-1")
      returnObj = {
        id: action.data.tokenConfigData.id,
        tokenConfigData: action.data.tokenConfigData,
        tokenConfigSortOrder: action.data.tokenConfigSortOrder,
        tokenConfigLinkSlug: action.data.tokenConfigLinkSlug,
        tokenConfigDisplayCategory: action.data.tokenConfigDisplayCategory,
        tokenConfigDisplayCategorySub:
          action.data.tokenConfigDisplayCategorySub,
      }
    } else {
      console.log("cond-2")

      returnObj = {
        tokenConfigData: state.forms.saveVideoCollection.tokenConfigData,
      }
    }
    return {
      ...state,
      isLoadingTokenConfig: false,
      forms: {
        ...state.forms,
        saveVideoCollection: {
          ...initialSaveVideoCollectionState,
          ...returnObj,
        },
      },
    }
  }

  if (action.type === "AIFILES_MANAGE") {
    console.log("AIFILES_MANAGE")
    console.log("action.data")
    console.log(action.data)
    console.log("state.forms.saveVideoCollection")
    console.log(state.forms.saveVideoCollection)

    if (action.data.mode === "add") {
      return {
        ...state,
        forms: {
          ...state.forms,
          saveVideoCollection: {
            ...state.forms.saveVideoCollection,
            [action.data.group]: [
              ...state.forms.saveVideoCollection[action.data.group],
              {
                id: action.data.id,
                filename: action.data.filename,
                filetype: action.data.filetype,
                subfolder: action.data.subfolder,
              },
            ],
          },
        },
      }
    } else if (action.data.mode === "delete") {
      return {
        ...state,
        forms: {
          ...state.forms,
          saveVideoCollection: {
            ...state.forms.saveVideoCollection,
            [action.data.group]: state.forms.saveVideoCollection[
              action.data.group
            ].filter((item, i) => item.id !== action.data.id),
          },
        },
      }
    }
    // Return the unchanged state for any other mode
    return state
  }

  if (action.type === "LOADING_PLANNER_GENERATE") {
    console.log("LOADING_PLANNER_GENERATE")
    return {
      ...state,
      isLoadingPlannerGenerate: action.data,
    }
  }
  if (action.type === "EVENT_ACCESS_ROLES_REPLACE") {
    console.log("EVENT_ACCESS_ROLES_REPLACE")
    return {
      ...state,
      eventAccessRoles: action.data,
      isLoading: false,
    }
  }
  if (action.type === "EVENT_ACCESS_ROLES_CREATED") {
    console.log("EVENT_ACCESS_ROLES_CREATED")
    return {
      ...state,
      eventAccessRoleCreateComplete: action.data,
      eventAccessRolesError: null,
    }
  }
  if (action.type === "EVENT_ACCESS_ROLES_ERROR") {
    console.log("EVENT_ACCESS_ROLES_ERROR")
    return {
      ...state,
      eventAccessRolesError: action.data,
      isLoading: false,
    }
  }

  if (action.type === "SET_PLANNER_CONTENT") {
    // Skip update if it's the same content to prevent loops
    if (
      JSON.stringify(action.payload) === JSON.stringify(state.plannerContent)
    ) {
      console.log("SET_PLANNER_CONTENT - Skipping identical update")
      return state
    }

    console.log("SET_PLANNER_CONTENT - New content set")
    return {
      ...state,
      plannerContent: action.payload,
    }
  }

  if (action.type === "UPDATE_PLANNER_CONTENT") {
    // Prevent redundant updates by checking if this is a new update
    if (action.plannerContent === state.plannerContent) {
      return state
    }

    console.log("UPDATE_PLANNER_CONTENT - New planner content update")
    return {
      ...state,
      plannerContent: action.plannerContent,
    }
  }

  if (action.type === "ADD_PLANNER_ATTRIBUTE") {
    console.log("ADD_PLANNER_ATTRIBUTE")
    console.log("action.payload:", action.payload)

    return {
      ...state,
      isNewPlannerAttribute: action.payload.mode,
    }
  }

  if (action.type === "SET_ATTRIBUTE_FILTER") {
    console.log("SET_ATTRIBUTE_FILTER")
    console.log("action.payload:", action.payload)

    return {
      ...state,
      attributeFilter: action.payload,
    }
  }

  return state
}
const createStore = () =>
  reduxCreateStore(reducer, initialState, applyMiddleware(thunk))

export default createStore
